import React from 'react';

/**
 * Unified text input (DESIGN-SYSTEM.md §2.3): 8px radius, neutral border, primary focus ring, Inter.
 */
export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(({ className = '', ...props }, ref) => (
  <input
    ref={ref}
    className={`w-full text-sm px-3 py-2 bg-surface text-text-strong border border-border-neutral rounded-lg placeholder:text-text-muted focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-colors ${className}`}
    {...props}
  />
));
Input.displayName = 'Input';
